<script lang="ts">
import { createGetEnvironmentQuery } from '$lib/api/environment';
import { ensureAssistedSetupCatalog } from '$lib/api/assisted-setup';

const environment = createGetEnvironmentQuery();

$effect(() => {
  const env = $environment.data;
  if (!env) {
    return;
  }
  void ensureAssistedSetupCatalog({
    environmentType: env.environmentType,
    appBaseUrl: env.appBaseUrl,
  }).catch(() => {
    // Catalog errors are surfaced via assistedSetupCatalogState for UI that needs them.
  });
});
</script>
